var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-12"},[_c('div',{staticClass:"page-title mb-2"},[_vm._v("แบบฟอร์มคำร้องขอใช้พื้นที่ "),_c('span',[(_vm.currentStep == 2 || _vm.currentStep == 3)?_c('Button',{attrs:{"theme":"4","min-width":"120px","disabled":_vm.isLoading},on:{"onClick":function($event){return _vm.autoField(_vm.currentStep)}}},[_vm._v(" autoField - step "+_vm._s(_vm.currentStep)+" ")]):_vm._e()],1)]),_c('StatusStep',{attrs:{"current-step":_vm.currentStep,"steps":_vm.documentSteps},on:{"onClick":_vm.jumpStep}})],1),_c('div',[(_vm.currentStep == 1)?_c('FisrtForm',{attrs:{"masterData":_vm.masterData,"form-data":_vm.firstForm}}):_vm._e(),(_vm.currentStep == 2)?_c('SecondForm',{attrs:{"masterData":_vm.masterData,"form-data":_vm.secondForm}}):_vm._e(),(_vm.currentStep == 3)?_c('ThirdForm',{attrs:{"masterData":_vm.masterData,"form-data":_vm.thirdForm}}):_vm._e(),(_vm.currentStep == 4)?_c('FourthForm',{attrs:{"masterData":_vm.masterData,"form-data":_vm.fourthForm}}):_vm._e(),(_vm.currentStep == 5)?_c('preview'):_vm._e()],1),_c('div',{staticClass:"d-flex justify-space-between"},[_c('Button',{attrs:{"theme":"2"},on:{"onClick":_vm.cancelled}},[_vm._v("ยกเลิก")]),_c('div',{staticClass:"flex-center"},[(_vm.currentStep == 1)?_c('div'):_c('div',[_c('Button',{attrs:{"theme":"3","min-width":"120px","masterData":_vm.masterData,"disabled":_vm.isLoading},on:{"onClick":_vm.backForm}},[_vm._v("< ย้อนกลับ")])],1),_c('Button',{attrs:{"theme":"4","min-width":"120px","masterData":_vm.masterData,"disabled":_vm.isLoading},on:{"onClick":function($event){return _vm.saveDraft(true)}}},[_vm._v("บันทึกฉบับร่าง")]),(_vm.currentStep == 5)?_c('Button',{attrs:{"theme":_vm.validate('one') &&
        _vm.validate('two_one') &&
        _vm.validate('two_two') &&
        _vm.validate('two_three') &&
        _vm.validate('two_five') &&
        _vm.validate('two_six') &&
        _vm.validate('two_seven') &&
        _vm.validate('two_eight') &&
        _vm.validate('two_nine') &&
        _vm.validate('two_ten') &&
        _vm.validate('two_eleven') &&
        _vm.validate('two_twelve') &&
        _vm.validate('two_thirteen') &&
        _vm.validate('three_one') &&
        _vm.validate('three_two') &&
        _vm.validate('three_three') &&
        _vm.validate('three_four')
        ? '1'
        : '2',"min-width":"120px","disabled":_vm.validate('one') &&
          _vm.validate('two_one') &&
          _vm.validate('two_two') &&
          _vm.validate('two_three') &&
          _vm.validate('two_five') &&
          _vm.validate('two_six') &&
          _vm.validate('two_seven') &&
          _vm.validate('two_eight') &&
          _vm.validate('two_nine') &&
          _vm.validate('two_ten') &&
          _vm.validate('two_eleven') &&
          _vm.validate('two_twelve') &&
          _vm.validate('two_thirteen') &&
          _vm.validate('three_one') &&
          _vm.validate('three_two') &&
          _vm.validate('three_three') &&
          _vm.validate('three_four')
          ? false
          : true},on:{"onClick":_vm.submitForm}},[_vm._v("ยื่นแบบฟอร์ม")]):_c('Button',{attrs:{"theme":"3","min-width":"120px","disabled":_vm.isLoading,"masterData":_vm.masterData},on:{"onClick":_vm.nextForm}},[_vm._v("ถัดไป")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }